import Link from "../../common/Link";

export default function ProfiloPage() {
    return <>
        <h1>Profilo</h1>
        <br />
        <Link href="/profilo/cambia-password">Cambia la password</Link>
        <br /><br />
        Effettua il <Link href="/logout">logout</Link>
    </>
}